// S41 : Club des Collectionneurs.
// Lot 3 : onglet latéral « −10 % OFFERTS ». Visible si le club est actif, ou en aperçu interne (réglage s41_club_apercu
// + ?s41_club=apercu + thème non publié). Jamais d'ouverture automatique. L'onglet s'efface dès qu'il recouvrirait un
// élément utile (mesure sur un repère invisible de même position, pour ne pas dépendre de l'animation).
// Lot 4 : fenêtre (dialogue modal) ouverte par l'onglet : focus sur le champ, focus piégé, Échap / croix / refus / voile
// ferment et rendent le focus à l'onglet ; contrôles du champ et du consentement.
// Lot 5 : envoi réel par le formulaire client de Shopify. Un marqueur de session, posé à l'envoi, permet de reconnaître le
// retour (?customer_posted=true ne prouve rien à lui seul). Écran 2 seulement au retour d'un envoi réussi fait depuis la
// fenêtre ; tant que le club n'est pas actif, il reste sous un bandeau « APERÇU INTERNE » (remise non active).
(() => {
  const onglet = document.getElementById('S41Onglet');
  const voile = document.getElementById('S41Club');
  if (!onglet) return;
  const actif = onglet.dataset.s41Actif === 'true';
  const role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
  const stock = (zone, cle) => ({
    lire() { try { return JSON.parse(window[zone].getItem(cle)); } catch (_) { return null; } },
    ecrire(v) { try { window[zone].setItem(cle, JSON.stringify(v)); } catch (_) { /* stockage indisponible */ } },
    effacer() { try { window[zone].removeItem(cle); } catch (_) { /* stockage indisponible */ } },
  });
  const marqueur = stock('sessionStorage', 's41-club-envoi'); // posé à l'envoi, valable 15 minutes
  const souvenir = stock('localStorage', 's41-club-inscrit'); // après inscription réussie (club actif) : onglet masqué 365 jours
  const m = marqueur.lire();
  const envoi = !!(m && m.t && Date.now() - m.t < 15 * 60 * 1000);
  const nonPublie = !!role && role !== 'main';
  const apercu = onglet.dataset.s41Apercu === 'true' && nonPublie && (new URLSearchParams(window.location.search).get('s41_club') === 'apercu' || (envoi && m.apercu === true));
  if (!actif && !apercu) { onglet.remove(); if (voile) voile.remove(); return; }
  const deja = souvenir.lire();
  if (actif && !apercu && !envoi && deja && Date.now() - deja < 365 * 24 * 3600 * 1000) { onglet.remove(); if (voile) voile.remove(); return; }
  onglet.hidden = false;

  /* ---------------- onglet (lot 3) ---------------- */
  const fantome = onglet.cloneNode(true);
  fantome.removeAttribute('id'); fantome.removeAttribute('aria-controls'); fantome.classList.add('s41-fantome'); fantome.setAttribute('aria-hidden', 'true'); fantome.tabIndex = -1;
  document.body.appendChild(fantome);

  const PROTEGES = [
    '.product__info-container', '.v2-packs', '.v2-tier', 'form[data-type="add-to-cart-form"]', 'product-form',
    'input', 'select', 'textarea', 'v2-sticky-atc', 'cart-drawer', '.menu-drawer', '[role="dialog"]:not(#S41Club)',
    'main p', 'main h1', 'main h2', 'main h3', 'main li:not(:has(img, video))', 'main .button', 'main a.button',
    'main [class*="prix"]', 'main [class*="price"]', 'footer p', 'footer a',
  ].join(',');
  const visible = (x) => x !== onglet && x !== fantome && !(voile && voile.contains(x)) && x.getClientRects().length > 0 && getComputedStyle(x).visibility !== 'hidden';
  const verifier = () => {
    const o = fantome.getBoundingClientRect();
    // tiroir ou menu ouvert (Dawn bloque alors le défilement du corps de page)
    const bloque = (el) => [...el.classList].some((c) => c.startsWith('overflow-hidden'));
    let gene = bloque(document.body) || bloque(document.documentElement);
    if (!gene) {
      gene = [...document.querySelectorAll(PROTEGES)].some((x) => {
        if (!visible(x)) return false;
        const a = x.getBoundingClientRect();
        return a.width > 0 && a.height > 0 && !(a.right <= o.left || a.left >= o.right || a.bottom <= o.top || a.top >= o.bottom);
      });
    }
    onglet.classList.toggle('is-masque', gene);
    onglet.setAttribute('aria-hidden', String(gene));
    onglet.tabIndex = gene ? -1 : 0;
  };
  let rq = 0;
  const planifier = () => { if (!rq) rq = requestAnimationFrame(() => { rq = 0; verifier(); }); };
  addEventListener('scroll', planifier, { passive: true });
  addEventListener('resize', planifier);
  new MutationObserver(planifier).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  verifier();
  setTimeout(verifier, 800); // images et polices chargées

  onglet.addEventListener('click', () => {
    document.dispatchEvent(new CustomEvent('s41:club-ouvrir', { detail: { source: 'onglet' } }));
  });

  /* ---------------- fenêtre (lot 4) et inscription réelle (lot 5) ---------------- */
  if (!voile) return;
  const form = voile.querySelector('#S41ClubForm');
  const email = voile.querySelector('#S41Email');
  const consent = voile.querySelector('#S41Consent');
  const errEmail = voile.querySelector('#S41ErreurEmail');
  const errConsent = voile.querySelector('#S41ErreurConsent');
  const etats = { formulaire: voile.querySelector('[data-s41-etat="formulaire"]'), code: voile.querySelector('[data-s41-etat="code"]') };
  const bandeau = voile.querySelector('[data-s41-bandeau]');
  const copieMsg = voile.querySelector('[data-s41-copie]');
  const envoyer = form.querySelector('[type="submit"]');
  const texteErreurEmail = errEmail.textContent;
  form.noValidate = true; // contrôles accessibles ci-dessous ; sans script, la validation native (required) s'applique
  let retour = null;

  const focalisables = () => [...voile.querySelectorAll('button, a[href], input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])')].filter((x) => !x.disabled && x.getClientRects().length);
  const montrer = (nom) => {
    Object.entries(etats).forEach(([k, el]) => { el.hidden = k !== nom; });
    voile.setAttribute('aria-labelledby', nom === 'code' ? 'S41TitreCode' : 'S41Titre');
  };
  const afficher = (nom) => {
    retour = retour || onglet;
    montrer(nom);
    voile.hidden = false;
    document.documentElement.classList.add('s41-club-ouvert');
  };
  const ouvrir = () => {
    if (!voile.hidden) return;
    retour = document.activeElement && document.activeElement !== document.body ? document.activeElement : onglet;
    bandeau.hidden = true; copieMsg.textContent = ''; errEmail.textContent = texteErreurEmail;
    afficher('formulaire');
    setTimeout(() => email.focus(), 0);
  };
  const fermer = () => {
    if (voile.hidden) return;
    voile.hidden = true;
    document.documentElement.classList.remove('s41-club-ouvert');
    const cible = retour && document.contains(retour) && !retour.classList.contains('is-masque') ? retour : onglet;
    if (cible && cible.focus) cible.focus({ preventScroll: true });
  };
  document.addEventListener('s41:club-ouvrir', ouvrir);
  voile.querySelectorAll('[data-s41-fermer]').forEach((b) => b.addEventListener('click', fermer));
  voile.addEventListener('click', (e) => { if (e.target === voile) fermer(); });
  voile.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { e.preventDefault(); fermer(); return; }
    if (e.key !== 'Tab') return;
    const f = focalisables(); if (!f.length) return;
    const a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });
  // clavier virtuel : garder le bouton atteignable
  email.addEventListener('focus', () => setTimeout(() => envoyer.scrollIntoView({ block: 'nearest' }), 300));

  const RE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  form.addEventListener('submit', (e) => {
    const okEmail = RE_EMAIL.test(email.value.trim());
    const okConsent = consent.checked;
    errEmail.hidden = okEmail; email.setAttribute('aria-invalid', String(!okEmail));
    errConsent.hidden = okConsent;
    if (!okEmail || !okConsent) { e.preventDefault(); (okEmail ? consent : email).focus(); return; }
    // envoi réel vers Shopify (formulaire client natif) : marqueur de session pour reconnaître le retour
    marqueur.ecrire({ t: Date.now(), apercu });
    envoyer.disabled = true; envoyer.setAttribute('aria-busy', 'true');
    // Shopify peut d'abord demander une vérification anti-robot (hCaptcha) : si elle est fermée ou échoue, la page reste
    // affichée ; le bouton redevient utilisable
    setTimeout(() => { envoyer.disabled = false; envoyer.removeAttribute('aria-busy'); }, 8000);
  });
  [email, consent].forEach((el) => el.addEventListener('input', () => {
    if (el === email && !errEmail.hidden && RE_EMAIL.test(email.value.trim())) { errEmail.hidden = true; email.setAttribute('aria-invalid', 'false'); }
    if (el === consent && consent.checked) errConsent.hidden = true;
  }));

  voile.querySelector('[data-s41-copier]').addEventListener('click', async () => {
    const code = voile.querySelector('#S41Code').textContent.trim();
    let ok = false;
    try { await navigator.clipboard.writeText(code); ok = true; } catch (_) {
      const t = document.createElement('textarea');
      t.value = code; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      voile.appendChild(t); t.select();
      try { ok = document.execCommand('copy'); } catch (__) { ok = false; }
      t.remove();
    }
    copieMsg.textContent = ok ? 'Code copié' : 'Copie impossible : notez le code CLUB10';
  });

  // retour de Shopify après un envoi fait depuis cette fenêtre (et seulement dans ce cas)
  const serveur = form.querySelector('[data-s41-serveur]');
  if (envoi && serveur) {
    marqueur.effacer();
    if (serveur.dataset.s41Serveur === 'succes') {
      if (!actif) {
        // aperçu interne : l'inscription a été transmise ; son enregistrement se vérifie dans Shopify ; la remise n'existe pas encore
        bandeau.textContent = 'APERÇU INTERNE — inscription transmise à Shopify (enregistrement à vérifier dans Clients) ; remise CLUB10 non configurée, non active.';
        bandeau.hidden = false;
      } else {
        souvenir.ecrire(Date.now());
      }
      afficher('code');
      setTimeout(() => etats.code.querySelector('.s41-titre').focus(), 0);
    } else {
      const msg = serveur.dataset.s41Message;
      afficher('formulaire');
      errEmail.textContent = msg ? `Inscription refusée : ${msg}` : 'Inscription impossible pour le moment. Réessayez.';
      errEmail.hidden = false; email.setAttribute('aria-invalid', 'true');
      setTimeout(() => email.focus(), 0);
    }
  }
})();
